var map = {
	"./Bg_Timeline.png": 73278,
	"./Blurred_bg.png": 65401,
	"./Chart.jpg": 40491,
	"./CreatePortfolioBlank.svg": 51233,
	"./Historical.jpg": 91815,
	"./Mask-group.png": 23841,
	"./Pattern.png": 54101,
	"./PatternNew.png": 48087,
	"./Plus.svg": 37539,
	"./PostTrade.png": 90115,
	"./Success.svg": 70844,
	"./Topistats.png": 55292,
	"./add-widget-popup/icon_01.png": 16882,
	"./add-widget-popup/icon_02.png": 47849,
	"./add-widget-popup/icon_03.png": 69728,
	"./add-widget-popup/icon_04.png": 21055,
	"./add-widget-popup/icon_05.png": 7766,
	"./add_widget/Image 168@2x.png": 178,
	"./add_widget/active.jpg": 14130,
	"./add_widget/activefriends.jpg": 72019,
	"./add_widget/activity_buysell.png": 46834,
	"./add_widget/activity_followunfollow.png": 31813,
	"./add_widget/activity_other.png": 53688,
	"./add_widget/activity_posts.png": 24067,
	"./add_widget/alerts_friends.png": 70711,
	"./add_widget/alerts_technical.png": 74217,
	"./add_widget/analyze_birdeye.png": 20691,
	"./add_widget/analyze_boardchart.png": 22055,
	"./add_widget/analyze_comparer.png": 41162,
	"./add_widget/analyze_paper.png": 84857,
	"./add_widget/analyze_screener.png": 13718,
	"./add_widget/analyze_watchlists.png": 75167,
	"./add_widget/badges.jpg": 92484,
	"./add_widget/bouncers.jpg": 42013,
	"./add_widget/bullish.jpg": 42424,
	"./add_widget/calendar_customs.png": 37467,
	"./add_widget/calendar_earnings.png": 38726,
	"./add_widget/calendar_economic.png": 72016,
	"./add_widget/cards_financials.png": 61248,
	"./add_widget/cards_fundamentals.png": 98652,
	"./add_widget/cards_performance.png": 43432,
	"./add_widget/cards_pricing.png": 84755,
	"./add_widget/cards_shorts.png": 17713,
	"./add_widget/cards_trading.png": 29833,
	"./add_widget/clipper-social-widget.png": 73748,
	"./add_widget/closefriends.jpg": 19855,
	"./add_widget/collection.jpg": 89268,
	"./add_widget/crypto.png": 23611,
	"./add_widget/custom-grid.jpg": 61496,
	"./add_widget/custom.jpg": 49881,
	"./add_widget/explore_buzz.png": 72659,
	"./add_widget/explore_glossary.png": 58360,
	"./add_widget/explore_markets.png": 49269,
	"./add_widget/explore_news.png": 90261,
	"./add_widget/explore_trends.png": 23724,
	"./add_widget/explore_wiki.png": 39140,
	"./add_widget/external_instagram.png": 70120,
	"./add_widget/external_snapchat.png": 83592,
	"./add_widget/external_twitter.png": 68277,
	"./add_widget/favouritefriends.jpg": 32096,
	"./add_widget/files_image.png": 73013,
	"./add_widget/files_pdf.png": 87164,
	"./add_widget/files_ppt.png": 94626,
	"./add_widget/files_word.png": 97972,
	"./add_widget/followers.png": 40743,
	"./add_widget/following.png": 75931,
	"./add_widget/gainers.jpg": 4329,
	"./add_widget/grid-active.jpg": 3449,
	"./add_widget/grid-activefriends.jpg": 52070,
	"./add_widget/grid-bouncers.jpg": 11182,
	"./add_widget/grid-bullish.jpg": 74466,
	"./add_widget/grid-closefriends.jpg": 93788,
	"./add_widget/grid-favouritefriends.jpg": 48131,
	"./add_widget/grid-gainers.jpg": 91232,
	"./add_widget/grid-loosers.jpg": 21160,
	"./add_widget/grid-overbought.jpg": 82320,
	"./add_widget/grid-recentfriends.jpg": 48123,
	"./add_widget/grid-swings.jpg": 98358,
	"./add_widget/grid-topfriends.jpg": 75243,
	"./add_widget/image_grid.png": 10594,
	"./add_widget/image_slider.png": 19265,
	"./add_widget/lock.jpg": 11317,
	"./add_widget/loosers.jpg": 69793,
	"./add_widget/marketplace_listen.png": 26401,
	"./add_widget/marketplace_popular.png": 79561,
	"./add_widget/markets_freegreed.png": 60017,
	"./add_widget/markets_highlights.png": 99641,
	"./add_widget/markets_indicators.png": 86880,
	"./add_widget/markets_newssentiments.png": 5205,
	"./add_widget/markets_sentiments.png": 42248,
	"./add_widget/markets_summary.png": 12012,
	"./add_widget/momentum.jpg": 51098,
	"./add_widget/news_breaking.png": 28069,
	"./add_widget/news_crypto.png": 7509,
	"./add_widget/news_press.png": 38493,
	"./add_widget/news_stock.png": 94230,
	"./add_widget/nft.png": 3522,
	"./add_widget/nft_openseatrending.png": 17041,
	"./add_widget/nft_ordinaltrending.png": 4663,
	"./add_widget/nft_overalltrending.png": 29027,
	"./add_widget/nft_rarbletrending.png": 75606,
	"./add_widget/overbought.jpg": 97175,
	"./add_widget/portfolio_balance.png": 29451,
	"./add_widget/portfolio_distributions.png": 17438,
	"./add_widget/portfolio_highlights.png": 38460,
	"./add_widget/portfolio_holdings.png": 49383,
	"./add_widget/portfolio_transactions.png": 75652,
	"./add_widget/pricehits.png": 23035,
	"./add_widget/private.png": 39863,
	"./add_widget/public.png": 57867,
	"./add_widget/recentfriends.jpg": 78854,
	"./add_widget/recommendations.png": 7950,
	"./add_widget/relations.png": 28249,
	"./add_widget/signals.png": 24625,
	"./add_widget/social-character-1.png": 35725,
	"./add_widget/social-character-2.png": 45046,
	"./add_widget/social-character-3.png": 23135,
	"./add_widget/social-friends-icon.png": 94587,
	"./add_widget/social.png": 3557,
	"./add_widget/socialize_clubs.png": 91361,
	"./add_widget/socialize_discussion.png": 75404,
	"./add_widget/socialize_dms.png": 43678,
	"./add_widget/socialize_rankings.png": 6957,
	"./add_widget/stock-chart-active.png": 74928,
	"./add_widget/stock-chart-bouncer.png": 24198,
	"./add_widget/stock-chart-gainers.png": 40783,
	"./add_widget/stock-chart-loosers.png": 59547,
	"./add_widget/stock-chart-momentum.png": 56128,
	"./add_widget/stock-chart-ohlc.png": 46388,
	"./add_widget/stock-chart-overbought.png": 17097,
	"./add_widget/stock-chart-price.png": 7555,
	"./add_widget/stock-chart-swings.png": 16111,
	"./add_widget/stock-chart-volume.png": 12064,
	"./add_widget/stock.png": 63284,
	"./add_widget/subscribers.png": 63603,
	"./add_widget/subscriptions.png": 83940,
	"./add_widget/summary.jpg": 23414,
	"./add_widget/swings.jpg": 15761,
	"./add_widget/ticker_custom.png": 45886,
	"./add_widget/ticker_traderverse.png": 67140,
	"./add_widget/topfriends.jpg": 80760,
	"./add_widget/topphotos.jpg": 94372,
	"./add_widget/trending.jpg": 64603,
	"./add_widget/volume.jpg": 84250,
	"./alpaca.svg": 22749,
	"./approveMTset.png": 81187,
	"./at-icon.svg": 30230,
	"./auth/Btn_SignIn-1.png": 35777,
	"./auth/Btn_SignIn-2.png": 86794,
	"./auth/Btn_SignIn-3.png": 42003,
	"./auth/Btn_SignIn-a.png": 51089,
	"./auth/Btn_SignIn-b.png": 74842,
	"./auth/Btn_SignIn-c.png": 64675,
	"./auth/auth-background.png": 18279,
	"./auth/auth-background2.png": 82677,
	"./auth/auth-header.png": 52516,
	"./auth/auth-header2.png": 39788,
	"./auth/desktop-glow.png": 69028,
	"./auth/fifth-glow.png": 21653,
	"./auth/form-bg.png": 51342,
	"./auth/frame-1.png": 93269,
	"./auth/frame-2.png": 7518,
	"./auth/frame-3.png": 78855,
	"./auth/frame-4.png": 3688,
	"./auth/frame-5.png": 43633,
	"./auth/mobile-frame-1.png": 52322,
	"./auth/mobile-frame-2.png": 16857,
	"./auth/mobile-frame-3.png": 19952,
	"./auth/mobile-frame-4.png": 62799,
	"./auth/mobile-frame-5.png": 23782,
	"./auth/mobile-glow-1.png": 46638,
	"./auth/mobile-glow-2.png": 16997,
	"./auth/mobile-glow-five.png": 81655,
	"./auth/mobile-glow-four.png": 14531,
	"./auth/mobile-glow-one.png": 77451,
	"./auth/mobile-glow-three.png": 40111,
	"./auth/mobile-glow-two.png": 4217,
	"./auth/mobile-signin-slider-bg.png": 84111,
	"./auth/sign-slider-bg.png": 5739,
	"./auth/space-bg.png": 24512,
	"./auth/success-tick.png": 96827,
	"./avatar_men.png": 91573,
	"./avatar_women.png": 15683,
	"./background_bg.jpg": 19677,
	"./badge-1.png": 55528,
	"./badge-2.png": 57155,
	"./badge-3.png": 39578,
	"./badges/AlphaUsers.png": 7032,
	"./badges/FirstFiveThousand.png": 22966,
	"./badges/GenesisSpecial.png": 53903,
	"./badges/inflow.png": 14637,
	"./badges/outflow.png": 79154,
	"./badges/stars.png": 95633,
	"./bat.png": 55058,
	"./baticon.png": 9349,
	"./bg.png": 91386,
	"./bitcoin.png": 83249,
	"./blur-images/blur_besttrades.png": 41153,
	"./blur-images/blur_favInvestment.png": 50832,
	"./blur-images/blur_fav_investment.png": 50531,
	"./blur-images/blur_friends.png": 4775,
	"./blur-images/blur_images.png": 69048,
	"./blur-images/blur_influencer.png": 77067,
	"./blur-images/blur_links.png": 80247,
	"./blur-images/blur_list.png": 2290,
	"./blur-images/blur_photos.png": 29949,
	"./blur-images/blur_playbook.png": 21415,
	"./blur-images/blur_portfolio.png": 66960,
	"./blur-images/blur_prediction.png": 6365,
	"./blur-images/blur_prediction1.png": 78400,
	"./blur-images/blur_prediction2.png": 75963,
	"./blur-images/blur_recommendations.png": 9372,
	"./blur-images/blur_topstats.png": 54680,
	"./blur-images/blur_trades.png": 17191,
	"./blur-images/blur_watchlist.png": 52225,
	"./brokerage/AJBELL-logo.svg": 83570,
	"./brokerage/Alpaca.svg": 55630,
	"./brokerage/BUX-logo.svg": 83723,
	"./brokerage/Design-1.svg": 22684,
	"./brokerage/Design-2.svg": 1711,
	"./brokerage/Design-4.svg": 48065,
	"./brokerage/Robinhood.png": 96048,
	"./brokerage/bg/AJ-BELL.svg": 49021,
	"./brokerage/bg/AJCover.svg": 18382,
	"./brokerage/bg/ALPACA.svg": 19205,
	"./brokerage/bg/AlpacaCover.svg": 88175,
	"./brokerage/bg/BINANCE.svg": 18350,
	"./brokerage/bg/BUX.svg": 30257,
	"./brokerage/bg/COINBASE.svg": 19984,
	"./brokerage/bg/COMMSEC.svg": 42783,
	"./brokerage/bg/CoinbaseCover.svg": 74713,
	"./brokerage/bg/ETRADE.svg": 91457,
	"./brokerage/bg/EtradeCover.svg": 47142,
	"./brokerage/bg/Exodus.svg": 17442,
	"./brokerage/bg/INTERACTIVE-BROKERS-FLEX.svg": 62979,
	"./brokerage/bg/KRAKEN.svg": 42842,
	"./brokerage/bg/Orange.svg": 36918,
	"./brokerage/bg/PNC.svg": 14441,
	"./brokerage/bg/PUBLIC.svg": 35483,
	"./brokerage/bg/QUESTRADE.svg": 40080,
	"./brokerage/bg/ROBINHOOD.svg": 65442,
	"./brokerage/bg/RobinhoodCover.svg": 85183,
	"./brokerage/bg/SCHWAB.svg": 77480,
	"./brokerage/bg/STAKEAUS.svg": 41511,
	"./brokerage/bg/TASTYTRADE.svg": 93717,
	"./brokerage/bg/TRADESTATION.svg": 76910,
	"./brokerage/bg/TRADIER.svg": 96751,
	"./brokerage/bg/TRADING212.svg": 25298,
	"./brokerage/bg/UNOCOIN.svg": 19259,
	"./brokerage/bg/UPSTOX.svg": 4719,
	"./brokerage/bg/VANGUARD.svg": 39050,
	"./brokerage/bg/WEALTHSIMPLETRADE.svg": 33213,
	"./brokerage/bg/WEBULL.svg": 40835,
	"./brokerage/bg/ZERODHA.svg": 65511,
	"./brokerage/bg/blue.svg": 60652,
	"./brokerage/bg/trust.svg": 94678,
	"./brokerage/icons/BlockFi.svg": 78723,
	"./brokerage/icons/Exodus.svg": 20967,
	"./brokerage/icons/Kraken.svg": 64543,
	"./brokerage/icons/Metamask.svg": 66830,
	"./brokerage/icons/alpaca.svg": 58635,
	"./brokerage/icons/coinbase.svg": 13125,
	"./brokerage/icons/cti.svg": 73009,
	"./brokerage/icons/gemni.svg": 57265,
	"./brokerage/icons/owner.png": 91828,
	"./brokerage/icons/owner.svg": 8862,
	"./brokerage/icons/pnc.svg": 76802,
	"./brokerage/icons/tree.svg": 89353,
	"./brokerage/icons/trust.svg": 75049,
	"./brokerage/icons/us.svg": 26797,
	"./brokerage/icons/wallet.svg": 61006,
	"./camera.png": 70862,
	"./chart-holding.png": 11949,
	"./chrome-icon.png": 11139,
	"./colleague.png": 83562,
	"./collections/1.jpg": 17392,
	"./collections/1.png": 6548,
	"./collections/10.png": 19694,
	"./collections/2.jpg": 32351,
	"./collections/2.png": 25455,
	"./collections/3.jpg": 12354,
	"./collections/3.png": 86438,
	"./collections/4.jpg": 8913,
	"./collections/4.png": 79513,
	"./collections/5.jpg": 30388,
	"./collections/5.png": 60227,
	"./collections/6.jpg": 32195,
	"./collections/6.png": 52459,
	"./collections/7.png": 31330,
	"./collections/8.png": 61925,
	"./collections/9.png": 48860,
	"./connect/asana.png": 42990,
	"./connect/behance.png": 60160,
	"./connect/discord.png": 14464,
	"./connect/dribbble.png": 51416,
	"./connect/facebook.png": 10022,
	"./connect/facebook.svg": 19670,
	"./connect/github.png": 55107,
	"./connect/google.png": 6311,
	"./connect/iconfinder_chrome_87865@2x.png": 99425,
	"./connect/instagram.png": 89556,
	"./connect/linkedin.png": 67440,
	"./connect/linkedin.svg": 79796,
	"./connect/mailchimp.png": 71550,
	"./connect/messenger.png": 20429,
	"./connect/reddit.png": 78566,
	"./connect/slack.png": 31484,
	"./connect/telegram.png": 97607,
	"./connect/twitter.png": 74761,
	"./connect/whatsapp.png": 8548,
	"./connect/whatsapp.svg": 87572,
	"./connect/x.png": 41832,
	"./course-img.png": 48406,
	"./discordIcon.png": 39976,
	"./discovery/Alphabet Inc.jpg": 8463,
	"./discovery/Apple Inc.jpg": 71592,
	"./discovery/Binance.png": 79574,
	"./discovery/Binance.svg": 96848,
	"./discovery/Bitcoin.png": 87058,
	"./discovery/Bitcoin.svg": 71820,
	"./discovery/Cardano.png": 28374,
	"./discovery/Cardano.svg": 34408,
	"./discovery/Cool Gorila Art.jpg": 84566,
	"./discovery/Donkey King.jpg": 57213,
	"./discovery/Ethereum.png": 59225,
	"./discovery/Ethereum.svg": 82581,
	"./discovery/Huntington.jpg": 42970,
	"./discovery/Magic Art.jpg": 75582,
	"./discovery/Monkey Art.jpg": 27554,
	"./discovery/Polkadot.png": 66448,
	"./discovery/Polkadot.svg": 7428,
	"./discovery/Space Art.jpg": 2409,
	"./discovery/Teck.jpg": 90501,
	"./discovery/Yahoo.jpg": 18260,
	"./discovery/alphabet_inc.svg": 96638,
	"./discovery/apple_teck.svg": 62658,
	"./discovery/com-1.jpg": 9897,
	"./discovery/com-10.jpg": 2773,
	"./discovery/com-2.jpg": 36190,
	"./discovery/com-3.jpg": 7323,
	"./discovery/com-4.jpg": 84648,
	"./discovery/com-5.jpg": 47013,
	"./discovery/com-6.jpg": 24410,
	"./discovery/com-7.jpg": 18871,
	"./discovery/com-8.jpg": 21156,
	"./discovery/com-9.jpg": 99201,
	"./discovery/group-1.jpg": 91099,
	"./discovery/group-1.png": 95075,
	"./discovery/group-10.jpg": 44035,
	"./discovery/group-10.png": 12715,
	"./discovery/group-2.jpg": 64652,
	"./discovery/group-2.png": 16744,
	"./discovery/group-3.jpg": 62441,
	"./discovery/group-3.png": 65137,
	"./discovery/group-4.jpg": 56602,
	"./discovery/group-4.png": 20574,
	"./discovery/group-5.jpg": 24887,
	"./discovery/group-5.png": 96359,
	"./discovery/group-6.jpg": 86216,
	"./discovery/group-6.png": 45676,
	"./discovery/group-7.jpg": 30181,
	"./discovery/group-7.png": 57301,
	"./discovery/group-8.jpg": 11190,
	"./discovery/group-8.png": 28146,
	"./discovery/group-9.jpg": 55955,
	"./discovery/group-9.png": 49691,
	"./discovery/huntington.svg": 32954,
	"./discovery/news-1.jpg": 97657,
	"./discovery/news-2.jpg": 41518,
	"./discovery/news-3.jpg": 67979,
	"./discovery/stock-5.svg": 99326,
	"./discovery/up.jpg": 27109,
	"./discovery/yahoo.svg": 45906,
	"./dropIconInfo.svg": 15507,
	"./dummy-cover.png": 64597,
	"./dummy-leaderboard.png": 56985,
	"./dummy-profile.png": 63831,
	"./dummy-qrcode.png": 84624,
	"./dummy_profile_twitter.png": 52301,
	"./emptyAccount.svg": 97095,
	"./envelope-icon.svg": 34815,
	"./event/DetailCover.png": 20958,
	"./event/arrow-right.png": 66864,
	"./event/avatar1.png": 41446,
	"./event/avatar2.png": 39005,
	"./event/avatar3.png": 17876,
	"./event/avatar4.png": 67787,
	"./event/avatar5.png": 77282,
	"./event/badge1.png": 40482,
	"./event/badge2.png": 54489,
	"./event/badge3.png": 38736,
	"./event/card1.png": 24557,
	"./event/card2.png": 92790,
	"./event/card3.png": 46591,
	"./event/card4.png": 18560,
	"./event/cardCover1.png": 45100,
	"./event/cardCover2.png": 47751,
	"./event/cardCover3.png": 95262,
	"./event/cardCover4.png": 78353,
	"./event/cardCover5.png": 68136,
	"./event/covermodal.png": 77992,
	"./event/event-empty.svg": 57680,
	"./event/g1.png": 56372,
	"./event/g2.png": 78831,
	"./event/g3.png": 10086,
	"./event/g4.png": 98713,
	"./event/icon/Assets-1.png": 5549,
	"./event/icon/Assets-2.png": 14870,
	"./event/icon/Assets.png": 24872,
	"./event/icon/ParticipantIcons.svg": 63009,
	"./event/icon/ParticipantIconsNew.svg": 24657,
	"./event/icon/PortfolioIcons.svg": 48808,
	"./event/icon/PortfolioIconsNew.svg": 80642,
	"./event/icon/Social0.svg": 34909,
	"./event/icon/Social1.svg": 45436,
	"./event/icon/Social2.svg": 24463,
	"./event/icon/Social3.svg": 80734,
	"./event/icon/Social4.svg": 94113,
	"./event/icon/arrow-down.svg": 53214,
	"./event/icon/calendar.svg": 6016,
	"./event/icon/cup.svg": 38158,
	"./event/icon/event.svg": 29990,
	"./event/icon/filter.svg": 69752,
	"./event/icon/location.svg": 78479,
	"./event/icon/paused.svg": 77460,
	"./event/icon/team-card-1.svg": 95090,
	"./event/icon/team-card.svg": 6300,
	"./event/icon/traderverse.svg": 57229,
	"./event/icon/view.svg": 11405,
	"./event/image-1.png": 63039,
	"./event/image-2.png": 9828,
	"./event/image-3.png": 63725,
	"./event/image.png": 7981,
	"./event/logo.png": 10893,
	"./event/rank-1.png": 81652,
	"./event/rank-2.png": 56143,
	"./event/rank-3.png": 17126,
	"./event/slot-1.png": 67822,
	"./event/slot-2.png": 70245,
	"./event/slot-3.png": 52732,
	"./event/slot-4.png": 36339,
	"./event/slot-5.png": 85578,
	"./event/sponsor-1.png": 31326,
	"./event/sponsor-2.png": 98677,
	"./event/sponsor-3.png": 29580,
	"./event/sponsor-4.png": 59747,
	"./event/sponsor-5.png": 42170,
	"./event/sponsor-6.png": 72337,
	"./event/sponsor-7.png": 74472,
	"./event/sponsor-8.png": 79116,
	"./event/sponsor-9.png": 60406,
	"./event/user-approved.svg": 28403,
	"./eye-icon.svg": 95452,
	"./favicon.png": 35963,
	"./finance/f-icon-1.svg": 18804,
	"./finance/f-icon-2.svg": 6663,
	"./finance/f-icon-3.svg": 3190,
	"./finance/f-icon-4.svg": 94777,
	"./finance/f-icon-5.svg": 86856,
	"./friend.png": 88419,
	"./guilds-img.png": 65793,
	"./icon-close.svg": 87435,
	"./icon-delete.png": 85758,
	"./icon-edit.svg": 83365,
	"./icon-new-profile_edit-two.png": 22711,
	"./icon-new-profile_edit.png": 77382,
	"./icon-portfolio-background.png": 60478,
	"./icon-portfolio.svg": 31707,
	"./icon-profile-badge.png": 62678,
	"./icon-profile-edit.svg": 12245,
	"./icon-profit-loss.svg": 34993,
	"./icon-recommendations.svg": 58775,
	"./icon-section.svg": 80826,
	"./icon_01.d375884e.png": 64670,
	"./icon_02.9f154055.png": 90524,
	"./icon_03.96b66539.png": 95512,
	"./icon_04.238dde17.png": 34319,
	"./icon_05.010ce385.png": 62779,
	"./leaderboard/arrow-left.svg": 52114,
	"./leaderboard/card-bg.png": 29229,
	"./leaderboard/cup-1.png": 16345,
	"./leaderboard/cup-2.png": 49762,
	"./leaderboard/cup-3.png": 23915,
	"./leaderboard/cup-4.png": 74004,
	"./leaderboard/profile-4.png": 57071,
	"./leaderboard/rank-1.png": 86795,
	"./leaderboard/rank-2-mask.png": 94175,
	"./leaderboard/rank-2.png": 15504,
	"./leaderboard/rank-3.png": 21753,
	"./leaderboard/uiface.jpg": 74782,
	"./leaderboard/user-frame.png": 14322,
	"./leaderboard/user-frame.svg": 29274,
	"./likeicon01.png": 7724,
	"./likeicon02.png": 76199,
	"./likeicon03.png": 4862,
	"./likeicon04.png": 40977,
	"./lock-icon.svg": 89852,
	"./loginbg.png": 39537,
	"./logo-bitcoin.png": 9819,
	"./logo-gif.png": 53731,
	"./logo-light-text.png": 99633,
	"./logo-private.png": 38660,
	"./logo.png": 82806,
	"./logo_transparent.png": 23373,
	"./manage-sections/1.png": 85081,
	"./manage-sections/2.png": 18498,
	"./manage-sections/3.png": 92651,
	"./manage-sections/4.png": 42740,
	"./manage-sections/5.png": 63869,
	"./manage-sections/6.png": 82662,
	"./markets/arrow-down.svg": 41229,
	"./markets/arrow-up.svg": 30130,
	"./markets/democratic.png": 43644,
	"./markets/republican.png": 35772,
	"./mediaCrad.png": 65515,
	"./mobile-icon.svg": 49789,
	"./new_badges/1.png": 36654,
	"./new_badges/2.png": 8453,
	"./new_badges/3.png": 95388,
	"./new_badges/4.png": 78995,
	"./new_badges/5.png": 23786,
	"./newlogo.png": 36360,
	"./news-default.svg": 1730,
	"./news/BBC.png": 89356,
	"./news/Facebook.svg": 89233,
	"./news/Frame.png": 32279,
	"./news/Link.svg": 921,
	"./news/Linkedin.svg": 16063,
	"./news/MaskGroup.png": 53842,
	"./news/Reddit.svg": 1617,
	"./news/Report.svg": 62995,
	"./news/Save.svg": 79854,
	"./news/ShareIcon.svg": 72729,
	"./news/Sharing.svg": 33955,
	"./news/Show.svg": 98710,
	"./news/Twitter.svg": 20798,
	"./news/ai.png": 26993,
	"./news/asa.svg": 37586,
	"./news/asas.svg": 66861,
	"./news/bloom.png": 90066,
	"./news/chart.png": 25091,
	"./news/cnn.png": 4080,
	"./news/crypto.png": 11416,
	"./news/defaultAvatar.svg": 52163,
	"./news/dot.svg": 27646,
	"./news/down.svg": 65809,
	"./news/fox.png": 36236,
	"./news/image6.png": 11752,
	"./news/images.png": 74933,
	"./news/images2.png": 11043,
	"./news/images3.png": 93466,
	"./news/images4.png": 49973,
	"./news/images5.png": 80876,
	"./news/kamla.png": 22707,
	"./news/level.svg": 95685,
	"./news/mark.png": 4624,
	"./news/nbc.svg": 76760,
	"./news/read.png": 35983,
	"./news/s1.png": 18563,
	"./news/s2.png": 33288,
	"./news/s3.png": 47505,
	"./news/s4.png": 6494,
	"./news/s5.png": 24807,
	"./news/serverPAK.png": 63544,
	"./news/serverUAE.png": 18407,
	"./news/serverUK.png": 51266,
	"./news/share.svg": 13754,
	"./news/today.png": 39800,
	"./news/uae.png": 540,
	"./news/up.svg": 88801,
	"./news/usa.png": 10206,
	"./news/usa2.png": 80174,
	"./news/usaa.png": 23765,
	"./no-data.png": 9977,
	"./no-data.svg": 16819,
	"./no-image.png": 87098,
	"./onlinefriend.png": 12974,
	"./payment/card.png": 65116,
	"./payment/visa.png": 16985,
	"./photodv.png": 84837,
	"./pie-chart.png": 26730,
	"./placeholder/placeholder_overview_news.svg": 44324,
	"./placeholder_img.png": 49652,
	"./plusicon.png": 93464,
	"./portfolio/1.png": 26767,
	"./portfolio/2.png": 4308,
	"./portfolio/3.png": 25437,
	"./portfolio/4.png": 32642,
	"./portfolio/5.png": 18680,
	"./portfolio/shade_rectangle.png": 78423,
	"./portfolio/shade_square.png": 1979,
	"./portfolio/widgets.svg": 32455,
	"./portfolio_accounts/PortfolioEmpty.png": 92866,
	"./portfolio_accounts/banking-1.png": 7765,
	"./portfolio_accounts/banking-2.png": 22014,
	"./portfolio_accounts/banking-3.png": 93351,
	"./portfolio_accounts/banking-4.png": 18184,
	"./portfolio_accounts/banking-5.png": 58129,
	"./portfolio_accounts/shade_Banking.png": 84709,
	"./portfolio_accounts/shade_Brokerage.png": 80067,
	"./portfolio_accounts/shade_Exchanges.png": 76229,
	"./portfolio_accounts/shade_Payment.png": 69193,
	"./portfolio_accounts/shade_Wallets.png": 49029,
	"./portfolio_brokerage/ally.png": 92529,
	"./portfolio_brokerage/ameri.png": 49743,
	"./portfolio_brokerage/charles.png": 18103,
	"./portfolio_brokerage/chase.png": 8065,
	"./portfolio_brokerage/etrade.png": 91282,
	"./portfolio_brokerage/fidelity.png": 26977,
	"./portfolio_brokerage/firsttrader.png": 11293,
	"./portfolio_brokerage/interactive.png": 75247,
	"./portfolio_brokerage/merilllynch.png": 74120,
	"./portfolio_brokerage/robinhood.png": 89177,
	"./portfolio_brokerage/tradestation.png": 92445,
	"./portfolio_brokerage/vanguard.png": 84425,
	"./portfolio_brokerage/webull.png": 76824,
	"./portfolio_brokerage/wells.png": 39024,
	"./portfolio_icon_coingate.png": 63610,
	"./portfolio_payment/amazonpay.png": 15135,
	"./portfolio_payment/apple.png": 67553,
	"./portfolio_payment/block.png": 11854,
	"./portfolio_payment/coingate.png": 97103,
	"./portfolio_payment/googlewallet.png": 7019,
	"./portfolio_payment/paypal.png": 13072,
	"./portfolio_payment/stripe.png": 95674,
	"./portfolio_stats/profile-stats-1.png": 15945,
	"./portfolio_stats/profile-stats-2.png": 50802,
	"./portfolio_stats/profile-stats-3.png": 16155,
	"./portfolio_stats/profile-stats-4.png": 6212,
	"./portfolio_wallets/binance.png": 6215,
	"./portfolio_wallets/blockfi.png": 53509,
	"./portfolio_wallets/coinbase.png": 33533,
	"./portfolio_wallets/crypto.png": 27701,
	"./portfolio_wallets/electrum.png": 38034,
	"./portfolio_wallets/exodus.png": 8639,
	"./portfolio_wallets/ftx.png": 74735,
	"./portfolio_wallets/gate.png": 28968,
	"./portfolio_wallets/gemini.png": 60276,
	"./portfolio_wallets/hyperledger.png": 30520,
	"./portfolio_wallets/kraken.png": 46111,
	"./portfolio_wallets/metamask.png": 81022,
	"./portfolio_wallets/nanoledger.png": 33944,
	"./portfolio_wallets/trezon.png": 21937,
	"./portfolio_wallets/trustwallet.png": 17568,
	"./pro-img.png": 36488,
	"./profile-icon.svg": 43552,
	"./profile_cover_placeholder.jpg": 45926,
	"./quoted_text/quoted_1.png": 58614,
	"./quoted_text/quoted_10.png": 34660,
	"./quoted_text/quoted_2.png": 90381,
	"./quoted_text/quoted_3.png": 27140,
	"./quoted_text/quoted_4.png": 81947,
	"./quoted_text/quoted_5.png": 60402,
	"./quoted_text/quoted_6.png": 8585,
	"./quoted_text/quoted_7.png": 84384,
	"./quoted_text/quoted_8.png": 44967,
	"./quoted_text/quoted_9.png": 69182,
	"./reactions/allgreen.png": 60310,
	"./reactions/angrybull.png": 55786,
	"./reactions/appreciated.png": 69292,
	"./reactions/bloodbath.png": 13793,
	"./reactions/crapmine.png": 76101,
	"./reactions/crashingdown.png": 89071,
	"./reactions/cryptomarket.png": 12307,
	"./reactions/deadweight.png": 56418,
	"./reactions/diamondhand.png": 9769,
	"./reactions/downchart.png": 22162,
	"./reactions/feelingsick.png": 52832,
	"./reactions/goldmine.png": 10555,
	"./reactions/heart.png": 67362,
	"./reactions/kingofthemarket.png": 83141,
	"./reactions/kiss.png": 98846,
	"./reactions/like.png": 37921,
	"./reactions/queenofthemarket.png": 60874,
	"./reactions/sadbull.png": 46161,
	"./reactions/shock.png": 7408,
	"./reactions/shocked.png": 53771,
	"./reactions/smirkingbull.png": 53179,
	"./reactions/tothemood.png": 34571,
	"./reactions/upchart.png": 93731,
	"./relative.png": 11147,
	"./section/background.png": 27911,
	"./shade_Exchanges.png": 32363,
	"./social/discord.png": 78015,
	"./social/facebook.png": 16019,
	"./social/instagram.png": 17059,
	"./social/linkdin.png": 90678,
	"./social/telegram.png": 56342,
	"./social/twitch.png": 24298,
	"./social/twitter.png": 95610,
	"./social/youtube.png": 42735,
	"./stock-details/camera.svg": 99432,
	"./stock-details/clock.svg": 92513,
	"./stock-details/default.svg": 78864,
	"./stock-details/dollar.svg": 70299,
	"./stock-details/emoji.svg": 57625,
	"./stock-details/exclamation-mark.svg": 58902,
	"./stock-details/facebook.svg": 60625,
	"./stock-details/globe.svg": 19460,
	"./stock-details/link.svg": 67609,
	"./stock-details/question-mark.svg": 51345,
	"./stock-details/twitter.svg": 66622,
	"./stocks/dummy-crypto.png": 71733,
	"./stocks/dummy-stock.png": 41078,
	"./symbol-t.png": 4268,
	"./systemIcon.png": 13839,
	"./temp/Chart.png": 77188,
	"./temp/barGraph.png": 88179,
	"./temp/newsImg1.jpg": 10917,
	"./temp/newsImg2.jpg": 88314,
	"./temp/overallGraph.png": 54967,
	"./temp/rangeGraph.png": 95431,
	"./temp/smallChart.png": 27369,
	"./temp/smallChart2.png": 16223,
	"./temp/smallSpeed.png": 36156,
	"./temp/speedometer.svg": 39707,
	"./temp/speedometer_small.svg": 85475,
	"./temp/verticalGuage.svg": 47471,
	"./textareaicon.png": 26886,
	"./trader-type.png": 37402,
	"./tv_logo.png": 93996,
	"./twoFactor.svg": 43130,
	"./wallpaper/bg-1.png": 37481,
	"./winning-card-bg.png": 51766,
	"./yahoo.png": 41947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;